export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <rect x="0.5" y="0.5" width="13" height="13" stroke="#FFBD3C" />
            <path d="M3 6.5L5.5 9L10.5 4" stroke="#FFBD3C" strokeWidth="1.2" strokeLinecap="square" />
        </svg>
    );
}
